<template>
    <Fragment>
        <div class="radio-group" @click="onChangePaymentRadio">
            <div class="radio-heading">
                <span class="radio-conteiner">
                    <input
                        type="radio"
                        name="payment_radio"
                        :value="payment_data"
                        v-model="payment_selected"
                        @change="onChangePaymentRadio()"
                    >
                </span>
                <span class="forma-conteiner">
                    <i class="fas fa-credit-card"></i>
                    Cartão de crédito
                </span>
            </div>
        </div>
        <div class="content-payment">
                <div v-if="payment_selected && payment_data.id == payment_selected.id">
                    <!--NUMBER CARD-->
                    <div class="form-group required-field">
                        <label for="numberCardPagSeguro">Número do Cartão de Crédito</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="numberCardPagSeguro"
                            name="numberCardPagSeguro"
                            :value="number"
                            v-mask="'#### #### #### ####'"
                            @input="$emit('update:number', $event.target.value)"
                            @change="setInstallments($event.target.value)"
                        />
                        <div v-if="validate.formPagSeguroCard.number.$error && !validate.formPagSeguroCard.number.required" class="required">* Obrigatório</div>
                        <div v-if="!cardValid" class="required">Não aceitamos esta bandeira de cartão</div>
                    </div>
                    <!--END NUMBER CARD-->
                    <!--HOLDER CARD-->
                    <div class="form-group required-field">
                        <label for="holderCardPagSeguro">Titular do cartão</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="holderCardPagSeguro"
                            name="holderCardPagSeguro"
                            v-uppercase
                            :value="holder"
                            @input="$emit('update:holder', $event.target.value)"
                        />
                        <div v-if="validate.formPagSeguroCard.holder.$error && !validate.formPagSeguroCard.holder.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END HOLDER CARD-->

                    <!--CPF-->
                    <div class="form-group required-field">
                        <label for="cpf">CPF do titular do cartão</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="cpfPagSeguro"
                            name="cpfPagSeguro"
                            v-mask="'###.###.###-##'"
                            :value="cpf"
                            @input="$emit('update:cpf', $event.target.value)"
                        />
                        <div v-if="validate.formPagSeguroCard.cpf.$error && !validate.formPagSeguroCard.cpf.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END CPF-->

                    <!--DATA DE NASCIMENTO-->
                    <div class="form-group required-field">
                        <label for="birth">Data de nascimento do titular</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="birthPagSeguro"
                            name="birthPagSeguro"
                            v-mask="'##/##/####'"
                            :value="birth"
                            @input="$emit('update:birth', $event.target.value)"
                        />
                        <div v-if="validate.formPagSeguroCard.birth.$error && !validate.formPagSeguroCard.birth.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END DATA DE NASCIMENTO-->

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group required-field mb-0">
                                <label>Vencimento do cartão</label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group required-field mb-0">
                                <label>Cvv</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <!--EXPIRY MONTH-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_month', $event.target.value)"
                            >
                                <option value="" selected>Mês</option>
                                <option v-for="count in 12" :key="count" :value="count < 10 ? '0'+count : count">{{ count < 10 ? '0'+count : count }}</option>
                            </select>
                            <div v-if="validate.formPagSeguroCard.expiry_month.$error && !validate.formPagSeguroCard.expiry_month.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY MONTH-->

                        <!--EXPIRY YEAR-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_year', $event.target.value)"
                            >
                                <option value="" selected>Ano</option>
                                <option v-for="(n, $index) in 12" :key="n" :value="$index + countDate">{{$index + countDate}}</option>
                            </select>
                            <div v-if="validate.formPagSeguroCard.expiry_year.$error && !validate.formPagSeguroCard.expiry_year.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY YEAR-->

                        <!--CVV CARD-->
                        <div class="col-md-4">
                            <input
                                type="text"
                                class="form-payment"
                                id="cvvPagSeguro"
                                name="cvvPagSeguro"
                                :max-length="maxlengthCvv"
                                placeholder="cvv"
                                @input="$emit('update:cvv', $event.target.value)"
                            />
                            <div
                                v-if="validate.formPagSeguroCard.cvv.$error && !validate.formPagSeguroCard.cvv.required"
                                class="required"
                            >
                                * Obrigatório
                            </div>
                        </div>
                        <!--END CVV CARD-->
                    </div>


                    <!--INSTALLMENTS-->
                    <div class="form-group required-field">
                        <label for="installments_yapay">Parcelas</label>
                         <select class="form-payment" @input="$emit('update:installment', $event.target.value);setPayment($event.target.value)">
                            <option  v-for="i in installments" :key="i.installment_number" :value="i.installment_number" :selected="i.installment_number == 1">
                                <!-- {{  i.split == 1
                                    ? "à vista - "+currency.money(i.value_split)
                                    : i.split+"x de "+currency.money(i.value_split)+
                                    (Math.round(totalAmount / i.split) < Math.round(i.value_split) ? " com juros":" sem juros" )
                                }} -->
                                {{showInstallment(i)}}
                            </option>
                        </select>
                        <div v-if="validate.formYapayCard.installment.$error && !validate.formYapayCard.installment.required" class="required">* Selecione uma parcela</div>
                    </div>
                    <!--END INSTALLMENTS-->
                </div>
        </div>
    </Fragment>
</template>

<script>
import {converterFloatReal} from '../../helpers/converterFloatReal'
import {Fragment}  from 'vue-fragment'
import moment from 'moment'
import {mapState, mapActions} from 'vuex'
import Currency from '../../helpers/parseCurrency'
import { swall } from '../../services/sweetAlert'

export default {
    name: 'PagSeguro',
     directives: {
        "uppercase": {
            update: function (el) {
                el.value = el.value.toUpperCase()
            }
        }
    },
    props: {
        //numero de parcelas sem juros definido pela empresa no painel administrativo
        interest_free_installments: {
            default: 0
        },
        payment_data: {
            required: true,
            default: Object,
            type: Object
        },
        payment_selected: {
            default: Object,
            type: Object
        },
        holder: {
            default: ''
        },
        number: {
            default: ''
        },
        expiry_month: {
            default: ''
        },
        expiry_year: {
            default: ''
        },
        cvv: {
            default: ''
        },
        installment: {
            default: ''
        },
        cpf: {
            default: ''
        },
        birth: {
            default: ''
        },
        validate: {
            required: true
        },
        shippingMethod:{
            default:null
        },
        total_with_fee: {
            default: Object,
            type: Object
        }
    },
    components: {
        Fragment
    },
    data() {
        return {
            moment: moment,
            maxlengthCvv: 3,
            installments: [],
            disabledInstallments: true,
            pagseguro: window.PagSeguroDirectPayment,
            countDate: 0,
            currency: Currency,
            cardValid: true,
            splittings_pagseguro:[]
        }
    },
    created() {
        this.countDate = parseInt(this.moment().format('YYYY'))
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemsCart"
        ]),
        ...mapActions("payment", [
            "ActionGetSimulationPagSeguro"
        ]),
        onChangeInstallment(event)
        {
            let selected = event.target.value.split(';')
            let itemsCart = this.itemsCart
            itemsCart.totalAmount = selected[2]
            this.ActionSetItemsCart(itemsCart)
        },
        onChangePaymentRadio(event)
        {
            this.$emit('onChangePayment', this.payment_data)
        },
        validNumberCard(event)
        {
            var self = this
            var numberCard = self.number
            if(numberCard.length < 6) {
                return
            }
            self.pagseguro.getBrand({
                cardBin: numberCard,
                success:function(response) {
                    self.cardValid = true
                    window.cardBrand = response.brand.name
                    self.maxlengthCvv = response.brand.cvvSize
                    self.getInstallments()
                },
                error:function(response){
                    if(response.error) {
                        self.cardValid = false
                    }
                }
            })
        },
        async getSimulation(data){
            let env = process.env.NODE_ENV == 'production' ? {env: "production"} : {env: "sandbox"}
            let result = await this.ActionGetSimulationPagSeguro(data);
            let splittings = result.data
            this.splittings_pagseguro = splittings
            this.installments = []
            let max_slpit = this.maxNumberOfInstallments
            for (let i = 0; i < max_slpit ; i++) {
                const element = splittings[i];
                this.installments.push(element)
            }
        },
        async setInstallments(value){
            let data = {
                card_bin:  value.slice(0, 7).replace(/\s+/g, ''),
                totalAmount:this.totalAmount
            }
            await this.getSimulation(data)
        },
        setPayment(index) {
            let total_fee = this.installments.find(el => el.installment_number == index)
            this.$emit('update:total_with_fee', total_fee.amount_fee)
        },
        showInstallment(index) {
           return `${index.installment_number == 1 ? 'À vista - ': index.installment_number + 'x de '}${this.currency.money(this.addInstallmentFeeToTotalAmount(index))} ${this.validateWithOrWithoutAditionals(index)}`;
        },
        validateWithOrWithoutAditionals(index) {
            if(Number(index.total_amount) > Number(this.totalAmount)){
                return "com juros";
            }
            return index == 1 ? '' : "sem juros";
        },
        addInstallmentFeeToTotalAmount(index) {
            return Number(index.installment_amount)
        },
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        totalAmount() {
            return this.itemsCart.totalAmount.toFixed(2)
        },
        maxNumberOfInstallments() {
            let installments = [this.maxInstallments, this.splittings_pagseguro?.length ?? 12]
            if(Number(this.payment_selected.price_min_split ?? null) > 0) {
                let split = Math.floor(this.totalAmount / Number(this.payment_selected.price_min_split))
                if(split > 12) {
                    split = 12;
                }else if(split < 1) {
                    split = 1
                }
                installments.push(split)
            }
            return Math.min.apply(Math, installments)
        },
        maxInstallments() {
            if( !this.payment_selected.max_installments || this.payment_selected.max_installments < 1 ) {
                return 12;
            }
            return this.payment_selected.max_installments
        },
    },
    watch:{
        async shippingMethod(val){
            if(!val)return
            if(!this.number)return
            let data = {
                card_bin: this.number.slice(0, 7).replace(/\s+/g, ''),
                totalAmount:this.totalAmount
            }
            if(this.payment_selected.payment_name == 'PAGSEGURO'){
                this.installments = null
                await this.getSimulation(data)
                let msg = "Selecione novamente as parcelas";
                return swall(msg, true, 'exclamation-circle', 'secondary',5)
            }
        }
    }
}
</script>
